/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getVolunteerProfile = /* GraphQL */ `
  query GetVolunteerProfile($id: ID!) {
    getVolunteerProfile(id: $id) {
      id
      authAccountID
      email
      firstName
      lastName
      gender
      dateOfBirth
      streetAddress
      city
      state
      zip
      website
      enneagram
      enneagramWing
      myersBriggs
      additionalInformation
      availabilityStringified
      latitude
      longitude
      skills {
        items {
          id
          skillID
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          skill {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      causes {
        items {
          id
          causeID
          cause {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const listVolunteerProfiles = /* GraphQL */ `
  query ListVolunteerProfiles(
    $filter: ModelVolunteerProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getOrganizationInvitation = /* GraphQL */ `
  query GetOrganizationInvitation($id: ID!) {
    getOrganizationInvitation(id: $id) {
      id
      code
      email
      name
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizationInvitations = /* GraphQL */ `
  query ListOrganizationInvitations(
    $filter: ModelOrganizationInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationInvitations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        email
        name
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVolunteerSkill = /* GraphQL */ `
  query GetVolunteerSkill($id: ID!) {
    getVolunteerSkill(id: $id) {
      id
      skillID
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
      skill {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
    }
  }
`;
export const listVolunteerSkills = /* GraphQL */ `
  query ListVolunteerSkills(
    $filter: ModelVolunteerSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        skillID
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        skill {
          id
          key
          name
          description
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getCause = /* GraphQL */ `
  query GetCause($id: ID!) {
    getCause(id: $id) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const listCauses = /* GraphQL */ `
  query ListCauses(
    $filter: ModelCauseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCauses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVolunteerCause = /* GraphQL */ `
  query GetVolunteerCause($id: ID!) {
    getVolunteerCause(id: $id) {
      id
      causeID
      cause {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listVolunteerCauses = /* GraphQL */ `
  query ListVolunteerCauses(
    $filter: ModelVolunteerCauseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerCauses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        causeID
        cause {
          id
          key
          name
          description
          createdAt
          updatedAt
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrganizationDetails = /* GraphQL */ `
  query GetOrganizationDetails($id: ID!) {
    getOrganizationDetails(id: $id) {
      id
      organizationID
      missionStatement
      serveStatement
      doStatement
      costToDoStatement
      missionArea
      annualBudget
      currentMonthlyRecurringDonors
      averageMonthlyRecurringDonation
      percentageOfBudgetFromIndividualDonors
      numberOfMajorDonors
      averageOneTimeDonation
      percentageOfBudgetFromGrants
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizationDetails = /* GraphQL */ `
  query ListOrganizationDetails(
    $filter: ModelOrganizationDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        missionStatement
        serveStatement
        doStatement
        costToDoStatement
        missionArea
        annualBudget
        currentMonthlyRecurringDonors
        averageMonthlyRecurringDonation
        percentageOfBudgetFromIndividualDonors
        numberOfMajorDonors
        averageOneTimeDonation
        percentageOfBudgetFromGrants
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProgram = /* GraphQL */ `
  query GetProgram($id: ID!) {
    getProgram(id: $id) {
      id
      organizationID
      name
      description
      theWhy
      leadID
      stringifiedCauses
      opportunities {
        items {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      archived
      createdAt
      updatedAt
      lead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listPrograms = /* GraphQL */ `
  query ListPrograms(
    $filter: ModelProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrograms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationID
        name
        description
        theWhy
        leadID
        stringifiedCauses
        opportunities {
          items {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          nextToken
        }
        archived
        createdAt
        updatedAt
        lead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getOpportunity = /* GraphQL */ `
  query GetOpportunity($id: ID!) {
    getOpportunity(id: $id) {
      id
      organizationID
      programID
      program {
        id
        organizationID
        name
        description
        theWhy
        leadID
        stringifiedCauses
        opportunities {
          items {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          nextToken
        }
        archived
        createdAt
        updatedAt
        lead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityLeadID
      type
      status
      startDate
      endDate
      startRecruitingDate
      headerImage
      title
      descriptionRTE
      theWhy
      expectedImpact
      whatWillHappen
      volunteerGain
      roles {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      stringifiedCauses
      stringifiedCausesJSON
      application {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          screeningCallRequired
          signUpOnly
          requireScreeningCall
          requireBackgroundCheck
          recruitmentDeadlineForVolunteers
          targetNumberOfVolunteerHours
          minimumNumberOfVolunteersRequired
          customApplicationQuestions {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      opportunityLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listOpportunities = /* GraphQL */ `
  query ListOpportunities(
    $filter: ModelOpportunityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOpportunities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getApplication = /* GraphQL */ `
  query GetApplication($id: ID!) {
    getApplication(id: $id) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      screeningCallRequired
      signUpOnly
      requireScreeningCall
      requireBackgroundCheck
      recruitmentDeadlineForVolunteers
      targetNumberOfVolunteerHours
      minimumNumberOfVolunteersRequired
      customApplicationQuestions {
        items {
          id
          applicationID
          application {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          questionText
          questionType
          required
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listApplications = /* GraphQL */ `
  query ListApplications(
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        screeningCallRequired
        signUpOnly
        requireScreeningCall
        requireBackgroundCheck
        recruitmentDeadlineForVolunteers
        targetNumberOfVolunteerHours
        minimumNumberOfVolunteersRequired
        customApplicationQuestions {
          items {
            id
            applicationID
            questionText
            questionType
            required
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomApplicationQuestion = /* GraphQL */ `
  query GetCustomApplicationQuestion($id: ID!) {
    getCustomApplicationQuestion(id: $id) {
      id
      applicationID
      application {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        screeningCallRequired
        signUpOnly
        requireScreeningCall
        requireBackgroundCheck
        recruitmentDeadlineForVolunteers
        targetNumberOfVolunteerHours
        minimumNumberOfVolunteersRequired
        customApplicationQuestions {
          items {
            id
            applicationID
            questionText
            questionType
            required
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      questionText
      questionType
      required
      createdAt
      updatedAt
    }
  }
`;
export const listCustomApplicationQuestions = /* GraphQL */ `
  query ListCustomApplicationQuestions(
    $filter: ModelCustomApplicationQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomApplicationQuestions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        applicationID
        application {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          screeningCallRequired
          signUpOnly
          requireScreeningCall
          requireBackgroundCheck
          recruitmentDeadlineForVolunteers
          targetNumberOfVolunteerHours
          minimumNumberOfVolunteersRequired
          customApplicationQuestions {
            nextToken
          }
          createdAt
          updatedAt
        }
        questionText
        questionType
        required
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRole = /* GraphQL */ `
  query GetRole($id: ID!) {
    getRole(id: $id) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      roleTitle
      opportunityTitle
      live
      roleCoordinatorID
      recurrence
      weeklyRecurrenceDays
      weeklyRecurrenceSameVolunteers
      volunteersPerShift
      differentNumberOfVolunteersPerShift
      volunteerCommitmentMonths
      volunteerCommitmentCanRenew
      roleRequirements
      ageRequirement
      minorsRequireSupervision
      stringifiedCauses
      stringifiedCausesJSON
      stringifiedSkills
      stringifiedSkillsJSON
      stringifiedCertifications
      shifts {
        items {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
      roleCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listRoles = /* GraphQL */ `
  query ListRoles(
    $filter: ModelRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getShift = /* GraphQL */ `
  query GetShift($id: ID!) {
    getShift(id: $id) {
      id
      type
      live
      name
      summary
      startDate
      startTime
      endDate
      endTime
      timezone
      timeFrame
      timeFrameString
      recurrence
      weeklyRecurringDay
      monthlyRecurrenceWeek
      monthlyRecurrenceDay
      flexibleHours
      flexibleTimePeriod
      volunteersNeeded
      volunteerCoordinatorID
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleStringifiedSkills
      roleStringifiedCauses
      locationID
      locationLongitude
      locationLatitude
      locationType
      locationZipEstimate
      locationVariousDescription
      createdAt
      updatedAt
      volunteerCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const listShifts = /* GraphQL */ `
  query ListShifts(
    $filter: ModelShiftFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShifts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getOpportunityTemplate = /* GraphQL */ `
  query GetOpportunityTemplate($id: ID!) {
    getOpportunityTemplate(id: $id) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listOpportunityTemplates = /* GraphQL */ `
  query ListOpportunityTemplates(
    $filter: ModelOpportunityTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOpportunityTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        name
        description
        templateJSON
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getRoleTemplate = /* GraphQL */ `
  query GetRoleTemplate($id: ID!) {
    getRoleTemplate(id: $id) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listRoleTemplates = /* GraphQL */ `
  query ListRoleTemplates(
    $filter: ModelRoleTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoleTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationID
        name
        description
        templateJSON
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getOrganizationGroup = /* GraphQL */ `
  query GetOrganizationGroup($id: ID!) {
    getOrganizationGroup(id: $id) {
      id
      organizationID
      groupName
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizationGroups = /* GraphQL */ `
  query ListOrganizationGroups(
    $filter: ModelOrganizationGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        groupName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrganizationVolunteer = /* GraphQL */ `
  query GetOrganizationVolunteer($id: ID!) {
    getOrganizationVolunteer(id: $id) {
      id
      organizationID
      volunteerProfileID
      status
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizationVolunteers = /* GraphQL */ `
  query ListOrganizationVolunteers(
    $filter: ModelOrganizationVolunteerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationVolunteers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        volunteerProfileID
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrganizationGroupVolunteer = /* GraphQL */ `
  query GetOrganizationGroupVolunteer($id: ID!) {
    getOrganizationGroupVolunteer(id: $id) {
      id
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizationGroupVolunteers = /* GraphQL */ `
  query ListOrganizationGroupVolunteers(
    $filter: ModelOrganizationGroupVolunteerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationGroupVolunteers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTimeCommitment = /* GraphQL */ `
  query GetTimeCommitment($id: ID!) {
    getTimeCommitment(id: $id) {
      id
      amount
      units
      period
      createdAt
      updatedAt
    }
  }
`;
export const listTimeCommitments = /* GraphQL */ `
  query ListTimeCommitments(
    $filter: ModelTimeCommitmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeCommitments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        amount
        units
        period
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVolunteerMatchRequest = /* GraphQL */ `
  query GetVolunteerMatchRequest($id: ID!) {
    getVolunteerMatchRequest(id: $id) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleRequestedID
      roleRequested {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      volunteerComments
      administrativeNotes
      scheduledCallID
      scheduledCall {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        startTime
        duration
        details
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleAssignedID
      roleAssigned {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      assignmentID
      assignment {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      organizationRejectionReason
      volunteerRejectionReason
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listVolunteerMatchRequests = /* GraphQL */ `
  query ListVolunteerMatchRequests(
    $filter: ModelVolunteerMatchRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerMatchRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getScheduledCall = /* GraphQL */ `
  query GetScheduledCall($id: ID!) {
    getScheduledCall(id: $id) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      startTime
      duration
      details
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listScheduledCalls = /* GraphQL */ `
  query ListScheduledCalls(
    $filter: ModelScheduledCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listScheduledCalls(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        startTime
        duration
        details
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getAssignment = /* GraphQL */ `
  query GetAssignment($id: ID!) {
    getAssignment(id: $id) {
      id
      status
      volunteerMatchRequestID
      volunteerMatchRequest {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      shiftID
      shift {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      administrativeNotes
      createdAt
      updatedAt
    }
  }
`;
export const listAssignments = /* GraphQL */ `
  query ListAssignments(
    $filter: ModelAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssignments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCheckIn = /* GraphQL */ `
  query GetCheckIn($id: ID!) {
    getCheckIn(id: $id) {
      id
      assignmentID
      shiftID
      opportunityID
      timeIn
      timeOut
      checkedInByVolunteerProfileID
      checkedInByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      checkedOutByVolunteerProfileID
      checkedOutByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCheckIns = /* GraphQL */ `
  query ListCheckIns(
    $filter: ModelCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckIns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        assignmentID
        shiftID
        opportunityID
        timeIn
        timeOut
        checkedInByVolunteerProfileID
        checkedInByVolunteer {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        checkedOutByVolunteerProfileID
        checkedOutByVolunteer {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotificationSettings = /* GraphQL */ `
  query GetNotificationSettings($id: ID!) {
    getNotificationSettings(id: $id) {
      id
      communicationsProfileID
      allowPushNotifications
      allowTextMessages
      allowEmail
      preference
      createdAt
      updatedAt
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const listNotificationSettings = /* GraphQL */ `
  query ListNotificationSettings(
    $filter: ModelNotificationSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communicationsProfileID
        allowPushNotifications
        allowTextMessages
        allowEmail
        preference
        createdAt
        updatedAt
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      nextToken
    }
  }
`;
export const getLatentOrganizationCode = /* GraphQL */ `
  query GetLatentOrganizationCode($id: ID!) {
    getLatentOrganizationCode(id: $id) {
      id
      code
      organizationID
      active
      emailRestricted
      emailHostRestriction
      fundraisingCampaignID
      presetFundraisingCampaignAmbassadorStatus
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
    }
  }
`;
export const listLatentOrganizationCodes = /* GraphQL */ `
  query ListLatentOrganizationCodes(
    $filter: ModelLatentOrganizationCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLatentOrganizationCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        organizationID
        active
        emailRestricted
        emailHostRestriction
        fundraisingCampaignID
        presetFundraisingCampaignAmbassadorStatus
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getSubscriptionDonationTier = /* GraphQL */ `
  query GetSubscriptionDonationTier($id: ID!) {
    getSubscriptionDonationTier(id: $id) {
      id
      fundraisingCampaignID
      name
      description
      amount
      features
      buttonText
      buttonColor
      default
      highlighted
      highlightedColor
      promoText
      createdAt
      updatedAt
    }
  }
`;
export const listSubscriptionDonationTiers = /* GraphQL */ `
  query ListSubscriptionDonationTiers(
    $filter: ModelSubscriptionDonationTierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionDonationTiers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        name
        description
        amount
        features
        buttonText
        buttonColor
        default
        highlighted
        highlightedColor
        promoText
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCampaignConversationFlow = /* GraphQL */ `
  query GetCampaignConversationFlow($id: ID!) {
    getCampaignConversationFlow(id: $id) {
      id
      fundraisingCampaignID
      name
      description
      default
      active
      actionMessageDefinitions {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      restricted
      useDefaultCta
      customCta
      allowAmbassadorSpecificCrowbarVideos
      generalCrowbarVideoURI
      deleted
      createdAt
      updatedAt
    }
  }
`;
export const listCampaignConversationFlows = /* GraphQL */ `
  query ListCampaignConversationFlows(
    $filter: ModelCampaignConversationFlowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignConversationFlows(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        name
        description
        default
        active
        actionMessageDefinitions {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        restricted
        useDefaultCta
        customCta
        allowAmbassadorSpecificCrowbarVideos
        generalCrowbarVideoURI
        deleted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getActionMessageDefinition = /* GraphQL */ `
  query GetActionMessageDefinition($id: ID!) {
    getActionMessageDefinition(id: $id) {
      id
      campaignConversationFlowID
      fundraisingCampaignID
      name
      description
      type
      messageTemplate
      onPositiveResponse
      onNegativeResponse
      otherResponses {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      reminderActionMessageDefinitionID
      reminderActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      reminderDelay
      sendReminderNotification
      reminderNotificationID
      beginningNode
      parentActionMessageDefinitionID
      parentActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      viewType
      createdAt
      updatedAt
    }
  }
`;
export const listActionMessageDefinitions = /* GraphQL */ `
  query ListActionMessageDefinitions(
    $filter: ModelActionMessageDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessageDefinitions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getActionMessage = /* GraphQL */ `
  query GetActionMessage($id: ID!) {
    getActionMessage(id: $id) {
      id
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      fundraisingCampaignAmbassadorContactID
      actionMessageDefinitionID
      actionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      sent
      sentTimestamp
      response
      responseTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const listActionMessages = /* GraphQL */ `
  query ListActionMessages(
    $filter: ModelActionMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        fundraisingCampaignAmbassadorContactID
        actionMessageDefinitionID
        actionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        sent
        sentTimestamp
        response
        responseTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProject = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      id
      status
      name
      description
      tasks {
        items {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTask = /* GraphQL */ `
  query GetTask($id: ID!) {
    getTask(id: $id) {
      id
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      isTopLevelTask
      name
      overview
      description
      descriptionRTE
      status
      complete
      assignments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          authAccountID
          staffProfileID
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      comments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          comment
          mediaURI
          postedByID
          createdAt
          updatedAt
          postedBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      subTasks {
        items {
          id
          parentTaskID
          parentTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          subTaskID
          subTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      mediaURI
      attachments {
        items {
          id
          taskID
          uploadedByID
          name
          description
          contentType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdByID
      actionURL
      dueDate
      blockedBy {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      blocking {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      createdBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const listTasks = /* GraphQL */ `
  query ListTasks(
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getTaskAttachment = /* GraphQL */ `
  query GetTaskAttachment($id: ID!) {
    getTaskAttachment(id: $id) {
      id
      taskID
      uploadedByID
      name
      description
      contentType
      createdAt
      updatedAt
    }
  }
`;
export const listTaskAttachments = /* GraphQL */ `
  query ListTaskAttachments(
    $filter: ModelTaskAttachmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAttachments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        taskID
        uploadedByID
        name
        description
        contentType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTaskBlocker = /* GraphQL */ `
  query GetTaskBlocker($id: ID!) {
    getTaskBlocker(id: $id) {
      id
      originTaskID
      originTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      blockerTaskID
      blockerTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const listTaskBlockers = /* GraphQL */ `
  query ListTaskBlockers(
    $filter: ModelTaskBlockerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskBlockers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        originTaskID
        originTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        blockerTaskID
        blockerTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSubTask = /* GraphQL */ `
  query GetSubTask($id: ID!) {
    getSubTask(id: $id) {
      id
      parentTaskID
      parentTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      subTaskID
      subTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listSubTasks = /* GraphQL */ `
  query ListSubTasks(
    $filter: ModelSubTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        parentTaskID
        parentTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        subTaskID
        subTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTaskComment = /* GraphQL */ `
  query GetTaskComment($id: ID!) {
    getTaskComment(id: $id) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      comment
      mediaURI
      postedByID
      createdAt
      updatedAt
      postedBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const listTaskComments = /* GraphQL */ `
  query ListTaskComments(
    $filter: ModelTaskCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        taskID
        task {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        comment
        mediaURI
        postedByID
        createdAt
        updatedAt
        postedBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getTaskAssignment = /* GraphQL */ `
  query GetTaskAssignment($id: ID!) {
    getTaskAssignment(id: $id) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      authAccountID
      staffProfileID
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listTaskAssignments = /* GraphQL */ `
  query ListTaskAssignments(
    $filter: ModelTaskAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAssignments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        taskID
        task {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        authAccountID
        staffProfileID
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getVolunteerProfileByEmail = /* GraphQL */ `
  query GetVolunteerProfileByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelVolunteerProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getVolunteerProfileByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getOrganizationInvitationByCode = /* GraphQL */ `
  query GetOrganizationInvitationByCode(
    $code: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrganizationInvitationByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        email
        name
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listVolunteerSkillsByVolunteer = /* GraphQL */ `
  query ListVolunteerSkillsByVolunteer(
    $volunteerProfileID: ID
    $skillID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVolunteerSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerSkillsByVolunteer(
      volunteerProfileID: $volunteerProfileID
      skillID: $skillID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        skillID
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        skill {
          id
          key
          name
          description
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listVolunteerCausesByVolunteer = /* GraphQL */ `
  query ListVolunteerCausesByVolunteer(
    $volunteerProfileID: ID
    $causeID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVolunteerCauseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerCausesByVolunteer(
      volunteerProfileID: $volunteerProfileID
      causeID: $causeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        causeID
        cause {
          id
          key
          name
          description
          createdAt
          updatedAt
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrganizationDetailsByOrganization = /* GraphQL */ `
  query ListOrganizationDetailsByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationDetailsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        missionStatement
        serveStatement
        doStatement
        costToDoStatement
        missionArea
        annualBudget
        currentMonthlyRecurringDonors
        averageMonthlyRecurringDonation
        percentageOfBudgetFromIndividualDonors
        numberOfMajorDonors
        averageOneTimeDonation
        percentageOfBudgetFromGrants
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listProgramsByOrganization = /* GraphQL */ `
  query ListProgramsByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProgramsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        name
        description
        theWhy
        leadID
        stringifiedCauses
        opportunities {
          items {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          nextToken
        }
        archived
        createdAt
        updatedAt
        lead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listOpportunitiesByOrganization = /* GraphQL */ `
  query ListOpportunitiesByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOpportunityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOpportunitiesByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listOpportunitiesByProgram = /* GraphQL */ `
  query ListOpportunitiesByProgram(
    $programID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOpportunityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOpportunitiesByProgram(
      programID: $programID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listApplicationsByOpportunity = /* GraphQL */ `
  query ListApplicationsByOpportunity(
    $opportunityID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApplicationsByOpportunity(
      opportunityID: $opportunityID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        screeningCallRequired
        signUpOnly
        requireScreeningCall
        requireBackgroundCheck
        recruitmentDeadlineForVolunteers
        targetNumberOfVolunteerHours
        minimumNumberOfVolunteersRequired
        customApplicationQuestions {
          items {
            id
            applicationID
            questionText
            questionType
            required
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCustomQuestionsByApplication = /* GraphQL */ `
  query ListCustomQuestionsByApplication(
    $applicationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCustomApplicationQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomQuestionsByApplication(
      applicationID: $applicationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        applicationID
        application {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          screeningCallRequired
          signUpOnly
          requireScreeningCall
          requireBackgroundCheck
          recruitmentDeadlineForVolunteers
          targetNumberOfVolunteerHours
          minimumNumberOfVolunteersRequired
          customApplicationQuestions {
            nextToken
          }
          createdAt
          updatedAt
        }
        questionText
        questionType
        required
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listRolesByOpportunity = /* GraphQL */ `
  query ListRolesByOpportunity(
    $opportunityID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRolesByOpportunity(
      opportunityID: $opportunityID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listShiftsByRole = /* GraphQL */ `
  query ListShiftsByRole(
    $roleID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelShiftFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShiftsByRole(
      roleID: $roleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listShiftsByRoleAndLocation = /* GraphQL */ `
  query ListShiftsByRoleAndLocation(
    $roleID: ID
    $locationID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShiftFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShiftsByRoleAndLocation(
      roleID: $roleID
      locationID: $locationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listOpportunityTemplatesByOrganization = /* GraphQL */ `
  query ListOpportunityTemplatesByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOpportunityTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOpportunityTemplatesByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        name
        description
        templateJSON
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listRoleTemplatesByOrganization = /* GraphQL */ `
  query ListRoleTemplatesByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelRoleTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoleTemplatesByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        name
        description
        templateJSON
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listVolunteerMatchRequestsByVolunteer = /* GraphQL */ `
  query ListVolunteerMatchRequestsByVolunteer(
    $volunteerProfileID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelVolunteerMatchRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerMatchRequestsByVolunteer(
      volunteerProfileID: $volunteerProfileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listVolunteerMatchRequestsByOrganization = /* GraphQL */ `
  query ListVolunteerMatchRequestsByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelVolunteerMatchRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerMatchRequestsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listVolunteerMatchRequestsByOpportunity = /* GraphQL */ `
  query ListVolunteerMatchRequestsByOpportunity(
    $opportunityID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelVolunteerMatchRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerMatchRequestsByOpportunity(
      opportunityID: $opportunityID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listVolunteerScheduledCalls = /* GraphQL */ `
  query ListVolunteerScheduledCalls(
    $volunteerProfileID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerScheduledCalls(
      volunteerProfileID: $volunteerProfileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        startTime
        duration
        details
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrganizationScheduledCalls = /* GraphQL */ `
  query ListOrganizationScheduledCalls(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationScheduledCalls(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        startTime
        duration
        details
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listAssignmentsByVolunteer = /* GraphQL */ `
  query ListAssignmentsByVolunteer(
    $volunteerProfileID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssignmentsByVolunteer(
      volunteerProfileID: $volunteerProfileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listAssignmentsByShift = /* GraphQL */ `
  query ListAssignmentsByShift(
    $shiftID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssignmentsByShift(
      shiftID: $shiftID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listAssignmentsByOpportunity = /* GraphQL */ `
  query ListAssignmentsByOpportunity(
    $opportunityID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssignmentsByOpportunity(
      opportunityID: $opportunityID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCheckInsByAssignment = /* GraphQL */ `
  query ListCheckInsByAssignment(
    $assignmentID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckInsByAssignment(
      assignmentID: $assignmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assignmentID
        shiftID
        opportunityID
        timeIn
        timeOut
        checkedInByVolunteerProfileID
        checkedInByVolunteer {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        checkedOutByVolunteerProfileID
        checkedOutByVolunteer {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCheckInsByShift = /* GraphQL */ `
  query ListCheckInsByShift(
    $shiftID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckInsByShift(
      shiftID: $shiftID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assignmentID
        shiftID
        opportunityID
        timeIn
        timeOut
        checkedInByVolunteerProfileID
        checkedInByVolunteer {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        checkedOutByVolunteerProfileID
        checkedOutByVolunteer {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrganizationsByCode = /* GraphQL */ `
  query ListOrganizationsByCode(
    $code: String
    $sortDirection: ModelSortDirection
    $filter: ModelLatentOrganizationCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationsByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        organizationID
        active
        emailRestricted
        emailHostRestriction
        fundraisingCampaignID
        presetFundraisingCampaignAmbassadorStatus
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrganizationCodesByOrganizationID = /* GraphQL */ `
  query ListOrganizationCodesByOrganizationID(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLatentOrganizationCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationCodesByOrganizationID(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        organizationID
        active
        emailRestricted
        emailHostRestriction
        fundraisingCampaignID
        presetFundraisingCampaignAmbassadorStatus
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listSubscriptionDonationTiersByFundraisingCampaign = /* GraphQL */ `
  query ListSubscriptionDonationTiersByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionDonationTierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionDonationTiersByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        name
        description
        amount
        features
        buttonText
        buttonColor
        default
        highlighted
        highlightedColor
        promoText
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCampaignConversationFlowsByFundraisingCampaign = /* GraphQL */ `
  query ListCampaignConversationFlowsByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignConversationFlowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignConversationFlowsByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        name
        description
        default
        active
        actionMessageDefinitions {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        restricted
        useDefaultCta
        customCta
        allowAmbassadorSpecificCrowbarVideos
        generalCrowbarVideoURI
        deleted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActionMessageDefinitionsByFundraisingCampaign = /* GraphQL */ `
  query ListActionMessageDefinitionsByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActionMessageDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessageDefinitionsByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActionMessageDefinitionsByCampaignConversationFlow = /* GraphQL */ `
  query ListActionMessageDefinitionsByCampaignConversationFlow(
    $campaignConversationFlowID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActionMessageDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessageDefinitionsByCampaignConversationFlow(
      campaignConversationFlowID: $campaignConversationFlowID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActionMessageDefinitionsByParentActionMessageDefinition = /* GraphQL */ `
  query ListActionMessageDefinitionsByParentActionMessageDefinition(
    $parentActionMessageDefinitionID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActionMessageDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessageDefinitionsByParentActionMessageDefinition(
      parentActionMessageDefinitionID: $parentActionMessageDefinitionID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActionMessagesByFundraisingCampaign = /* GraphQL */ `
  query ListActionMessagesByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActionMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessagesByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        fundraisingCampaignAmbassadorContactID
        actionMessageDefinitionID
        actionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        sent
        sentTimestamp
        response
        responseTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActionMessagesByFundraisingCampaignAmbassadorID = /* GraphQL */ `
  query ListActionMessagesByFundraisingCampaignAmbassadorID(
    $fundraisingCampaignAmbassadorID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActionMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessagesByFundraisingCampaignAmbassadorID(
      fundraisingCampaignAmbassadorID: $fundraisingCampaignAmbassadorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        fundraisingCampaignAmbassadorContactID
        actionMessageDefinitionID
        actionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        sent
        sentTimestamp
        response
        responseTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActionMessagesByFundraisingCampaignAmbassadorContactID = /* GraphQL */ `
  query ListActionMessagesByFundraisingCampaignAmbassadorContactID(
    $fundraisingCampaignAmbassadorContactID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActionMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessagesByFundraisingCampaignAmbassadorContactID(
      fundraisingCampaignAmbassadorContactID: $fundraisingCampaignAmbassadorContactID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        fundraisingCampaignAmbassadorContactID
        actionMessageDefinitionID
        actionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        sent
        sentTimestamp
        response
        responseTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActionMessagesByDefinition = /* GraphQL */ `
  query ListActionMessagesByDefinition(
    $actionMessageDefinitionID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelActionMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionMessagesByDefinition(
      actionMessageDefinitionID: $actionMessageDefinitionID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        fundraisingCampaignAmbassadorContactID
        actionMessageDefinitionID
        actionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        sent
        sentTimestamp
        response
        responseTimestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listTasksByProject = /* GraphQL */ `
  query ListTasksByProject(
    $projectID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasksByProject(
      projectID: $projectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listTaskAttachmentsByTask = /* GraphQL */ `
  query ListTaskAttachmentsByTask(
    $taskID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskAttachmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAttachmentsByTask(
      taskID: $taskID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskID
        uploadedByID
        name
        description
        contentType
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listTaskBlockersByOriginTask = /* GraphQL */ `
  query ListTaskBlockersByOriginTask(
    $originTaskID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskBlockerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskBlockersByOriginTask(
      originTaskID: $originTaskID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        originTaskID
        originTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        blockerTaskID
        blockerTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listTaskBlockersByBlockerTask = /* GraphQL */ `
  query ListTaskBlockersByBlockerTask(
    $blockerTaskID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskBlockerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskBlockersByBlockerTask(
      blockerTaskID: $blockerTaskID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        originTaskID
        originTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        blockerTaskID
        blockerTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listSubTasksByParentTask = /* GraphQL */ `
  query ListSubTasksByParentTask(
    $parentTaskID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSubTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubTasksByParentTask(
      parentTaskID: $parentTaskID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentTaskID
        parentTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        subTaskID
        subTask {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listTaskCommentsByTask = /* GraphQL */ `
  query ListTaskCommentsByTask(
    $taskID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskCommentsByTask(
      taskID: $taskID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskID
        task {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        comment
        mediaURI
        postedByID
        createdAt
        updatedAt
        postedBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listTaskAssignmentsByTask = /* GraphQL */ `
  query ListTaskAssignmentsByTask(
    $taskID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAssignmentsByTask(
      taskID: $taskID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskID
        task {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        authAccountID
        staffProfileID
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listTaskAssignmentsByAuthAccount = /* GraphQL */ `
  query ListTaskAssignmentsByAuthAccount(
    $authAccountID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAssignmentsByAuthAccount(
      authAccountID: $authAccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskID
        task {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        authAccountID
        staffProfileID
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listTaskAssignmentsByStaffProfile = /* GraphQL */ `
  query ListTaskAssignmentsByStaffProfile(
    $staffProfileID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAssignmentsByStaffProfile(
      staffProfileID: $staffProfileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskID
        task {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        authAccountID
        staffProfileID
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const searchPrograms = /* GraphQL */ `
  query SearchPrograms(
    $filter: SearchableProgramFilterInput
    $sort: SearchableProgramSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchPrograms(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        organizationID
        name
        description
        theWhy
        leadID
        stringifiedCauses
        opportunities {
          items {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          nextToken
        }
        archived
        createdAt
        updatedAt
        lead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
      total
    }
  }
`;
export const searchOpportunities = /* GraphQL */ `
  query SearchOpportunities(
    $filter: SearchableOpportunityFilterInput
    $sort: SearchableOpportunitySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOpportunities(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
      total
    }
  }
`;
export const searchRoles = /* GraphQL */ `
  query SearchRoles(
    $filter: SearchableRoleFilterInput
    $sort: SearchableRoleSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchRoles(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
      total
    }
  }
`;
export const searchShifts = /* GraphQL */ `
  query SearchShifts(
    $filter: SearchableShiftFilterInput
    $sort: SearchableShiftSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchShifts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
      total
    }
  }
`;
export const searchOrganizationVolunteers = /* GraphQL */ `
  query SearchOrganizationVolunteers(
    $filter: SearchableOrganizationVolunteerFilterInput
    $sort: SearchableOrganizationVolunteerSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOrganizationVolunteers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        organizationID
        volunteerProfileID
        status
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const getCognitoAccount = /* GraphQL */ `
  query GetCognitoAccount($id: ID!) {
    getCognitoAccount(id: $id) {
      id
      cognitoID
      authAccountID
      createdAt
      updatedAt
      owner
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const listCognitoAccounts = /* GraphQL */ `
  query ListCognitoAccounts(
    $filter: ModelCognitoAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCognitoAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cognitoID
        authAccountID
        createdAt
        updatedAt
        owner
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listCognitoAccountsByAuthAccount = /* GraphQL */ `
  query ListCognitoAccountsByAuthAccount(
    $authAccountID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCognitoAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCognitoAccountsByAuthAccount(
      authAccountID: $authAccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoID
        authAccountID
        createdAt
        updatedAt
        owner
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getCognitoAccountByCognitoID = /* GraphQL */ `
  query GetCognitoAccountByCognitoID(
    $cognitoID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCognitoAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCognitoAccountByCognitoID(
      cognitoID: $cognitoID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoID
        authAccountID
        createdAt
        updatedAt
        owner
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getAuthAccount = /* GraphQL */ `
  query GetAuthAccount($id: ID!) {
    getAuthAccount(id: $id) {
      id
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      lastSelectedStaffProfileID
      lastSelectedFundraisingProfileID
      communicationsProfileID
      name
      firstName
      lastName
      primaryEmail
      phoneNumber
      dateOfBirth
      gender
      selfDescribedGender
      addressID
      website
      resumeURI
      bio
      profilePictureURI
      headerVideoURI
      headerImageURI
      headerAssetShown
      flourishAdmin
      createdAt
      updatedAt
      cognitoAccounts {
        items {
          id
          cognitoID
          authAccountID
          createdAt
          updatedAt
          owner
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      staffProfile {
        items {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      lastSelectedStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      fundraisingProfiles {
        items {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        nextToken
      }
      lastSelectedFundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const listAuthAccounts = /* GraphQL */ `
  query ListAuthAccounts(
    $filter: ModelAuthAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAuthAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const getAuthAccountByVolunteerProfileID = /* GraphQL */ `
  query GetAuthAccountByVolunteerProfileID(
    $volunteerProfileID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAuthAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAuthAccountByVolunteerProfileID(
      volunteerProfileID: $volunteerProfileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const listAuthAccountsByEmail = /* GraphQL */ `
  query ListAuthAccountsByEmail(
    $primaryEmail: String
    $sortDirection: ModelSortDirection
    $filter: ModelAuthAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAuthAccountsByEmail(
      primaryEmail: $primaryEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const listAuthAccountsByPhoneNumber = /* GraphQL */ `
  query ListAuthAccountsByPhoneNumber(
    $phoneNumber: String
    $sortDirection: ModelSortDirection
    $filter: ModelAuthAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAuthAccountsByPhoneNumber(
      phoneNumber: $phoneNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const getStaffProfile = /* GraphQL */ `
  query GetStaffProfile($id: ID!) {
    getStaffProfile(id: $id) {
      id
      authAccountID
      organizationID
      role
      name
      nylasAccountID
      nylasCalendarToken
      nylasPrimaryCalendarID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listStaffProfiles = /* GraphQL */ `
  query ListStaffProfiles(
    $filter: ModelStaffProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listStaffProfilesByAuthAccount = /* GraphQL */ `
  query ListStaffProfilesByAuthAccount(
    $authAccountID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelStaffProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffProfilesByAuthAccount(
      authAccountID: $authAccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const listStaffProfilesByOrganization = /* GraphQL */ `
  query ListStaffProfilesByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelStaffProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffProfilesByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getCommunicationsProfile = /* GraphQL */ `
  query GetCommunicationsProfile($id: ID!) {
    getCommunicationsProfile(id: $id) {
      id
      authAccountID
      streamJwt
      notificationSettingsID
      notificationSettings {
        id
        communicationsProfileID
        allowPushNotifications
        allowTextMessages
        allowEmail
        preference
        createdAt
        updatedAt
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
    }
  }
`;
export const listCommunicationsProfiles = /* GraphQL */ `
  query ListCommunicationsProfiles(
    $filter: ModelCommunicationsProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunicationsProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const getCommunicationsProfileByAuthAccount = /* GraphQL */ `
  query GetCommunicationsProfileByAuthAccount(
    $authAccountID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCommunicationsProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCommunicationsProfileByAuthAccount(
      authAccountID: $authAccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const getFundraisingProfile = /* GraphQL */ `
  query GetFundraisingProfile($id: ID!) {
    getFundraisingProfile(id: $id) {
      id
      authAccountID
      organizationID
      email
      firstName
      lastName
      classyMemberID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      campaigns {
        items {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listFundraisingProfiles = /* GraphQL */ `
  query ListFundraisingProfiles(
    $filter: ModelFundraisingProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listFundraisingProfilesByAuthAccount = /* GraphQL */ `
  query ListFundraisingProfilesByAuthAccount(
    $authAccountID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingProfilesByAuthAccount(
      authAccountID: $authAccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listFundraisingProfilesByOrganization = /* GraphQL */ `
  query ListFundraisingProfilesByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingProfilesByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getFundraisingProfileByAuthAccountAndOrganization = /* GraphQL */ `
  query GetFundraisingProfileByAuthAccountAndOrganization(
    $authAccountID: ID
    $organizationID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getFundraisingProfileByAuthAccountAndOrganization(
      authAccountID: $authAccountID
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getStaffInvitation = /* GraphQL */ `
  query GetStaffInvitation($id: ID!) {
    getStaffInvitation(id: $id) {
      id
      code
      type
      email
      domain
      name
      organizationID
      authAccountID
      staffProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listStaffInvitations = /* GraphQL */ `
  query ListStaffInvitations(
    $filter: ModelStaffInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffInvitations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        type
        email
        domain
        name
        organizationID
        authAccountID
        staffProfileID
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getStaffInvitationByCode = /* GraphQL */ `
  query GetStaffInvitationByCode(
    $code: ID
    $sortDirection: ModelSortDirection
    $filter: ModelStaffInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getStaffInvitationByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        type
        email
        domain
        name
        organizationID
        authAccountID
        staffProfileID
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getFundraisingInvitation = /* GraphQL */ `
  query GetFundraisingInvitation($id: ID!) {
    getFundraisingInvitation(id: $id) {
      id
      code
      email
      firstName
      lastName
      domain
      name
      organizationID
      authAccountID
      fundraisingProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listFundraisingInvitations = /* GraphQL */ `
  query ListFundraisingInvitations(
    $filter: ModelFundraisingInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingInvitations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        email
        firstName
        lastName
        domain
        name
        organizationID
        authAccountID
        fundraisingProfileID
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getFundraisingInvitationByCode = /* GraphQL */ `
  query GetFundraisingInvitationByCode(
    $code: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getFundraisingInvitationByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        email
        firstName
        lastName
        domain
        name
        organizationID
        authAccountID
        fundraisingProfileID
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getVolunteerInvitation = /* GraphQL */ `
  query GetVolunteerInvitation($id: ID!) {
    getVolunteerInvitation(id: $id) {
      id
      code
      email
      name
      firstName
      lastName
      organizationID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const listVolunteerInvitations = /* GraphQL */ `
  query ListVolunteerInvitations(
    $filter: ModelVolunteerInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerInvitations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        email
        name
        firstName
        lastName
        organizationID
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const volunteerInvitationByCode = /* GraphQL */ `
  query VolunteerInvitationByCode(
    $code: String
    $sortDirection: ModelSortDirection
    $filter: ModelVolunteerInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    volunteerInvitationByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        email
        name
        firstName
        lastName
        organizationID
        used
        usedTimestamp
        invitationSent
        invitationSentTimestamp
        createdAt
        updatedAt
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const getVolunteerWaitlist = /* GraphQL */ `
  query GetVolunteerWaitlist($id: ID!) {
    getVolunteerWaitlist(id: $id) {
      id
      firstName
      lastName
      email
      zipCode
      about
      invited
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listVolunteerWaitlists = /* GraphQL */ `
  query ListVolunteerWaitlists(
    $filter: ModelVolunteerWaitlistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVolunteerWaitlists(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        zipCode
        about
        invited
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getSkill = /* GraphQL */ `
  query GetSkill($id: ID!) {
    getSkill(id: $id) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const listSkills = /* GraphQL */ `
  query ListSkills(
    $filter: ModelSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      shortName
      description
      locationID
      website
      phoneNumber
      stripeConnectedAccountID
      stripeConnectedAccountStatus
      headerImageURI
      ambassadorTermOverrideSingular
      ambassadorTermOverridePlural
      streamJwt
      latentSubscription
      primaryColor
      secondaryColor
      designation
      detailsID
      details {
        id
        organizationID
        missionStatement
        serveStatement
        doStatement
        costToDoStatement
        missionArea
        annualBudget
        currentMonthlyRecurringDonors
        averageMonthlyRecurringDonation
        percentageOfBudgetFromIndividualDonors
        numberOfMajorDonors
        averageOneTimeDonation
        percentageOfBudgetFromGrants
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      owner
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
    }
  }
`;
export const searchOrganizations = /* GraphQL */ `
  query SearchOrganizations(
    $filter: SearchableOrganizationFilterInput
    $sort: SearchableOrganizationSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOrganizations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      nextToken
      total
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      type
      name
      details
      addressID
      organizationID
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const listLocationsByOrganization = /* GraphQL */ `
  query ListLocationsByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const getAddress = /* GraphQL */ `
  query GetAddress($id: ID!) {
    getAddress(id: $id) {
      id
      streetAddress
      unit
      city
      state
      zip
      zipPlusFour
      longitude
      latitude
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listAddresses = /* GraphQL */ `
  query ListAddresses(
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getFundraisingCampaign = /* GraphQL */ `
  query GetFundraisingCampaign($id: ID!) {
    getFundraisingCampaign(id: $id) {
      id
      type
      organizationID
      staffLeadID
      campaignName
      introVideoURI
      textMessageTemplate
      initialMessageReminderTemplate
      phoneCallScriptTemplate
      followUpMessageTemplate
      followUpYesMessageTemplate
      followUpNoMessageTemplate
      followUpReminderMessageTemplate
      showVideo
      showText
      showCall
      showFollowUp
      active
      publicVideoID
      publicVideoProvider
      campaignStartDate
      campaignStartTime
      campaignTimeZone
      campaignEndDate
      campaignEndTime
      publicCampaignAbout
      publicCampaignIntro
      campaignGoal
      perAmbassadorGoal
      totalAmbassadorsGoal
      perContactDonationGoal
      progressChartType
      ctaURL
      pageLayout
      primaryColor
      secondaryColor
      buttonBackgroundColor
      buttonTextColor
      customHeaderImageUploaded
      customLogoImageUploaded
      headerFont
      bodyFont
      ctaButtonText
      givingCircleBaseAmount
      givingCircleIncrements
      givingCircleAllowCustomAmounts
      ambassadorSpecificVideoUrlEnabled
      ambassadorCanUploadVideoUrl
      ambassadorSpecificCtaUrlEnabled
      ambassadorCanUploadCtaUrl
      crowbarVideoURL
      recruitmentForCampaignID
      classyCampaignID
      classyAutogenerateAmbassadorTeams
      classyDonationPageHostURL
      useClassyCtaURL
      useClassyFundraiserPage
      personalFundraisingCampaignID
      onDemandDiscoveryMeetingEnabled
      onDemandDiscoveryMeetingURL
      onDemandDiscoveryMeetingID
      onDemandDiscoveryMeetingInvitationCode
      CampaignConversationFlows {
        items {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        nextToken
      }
      defaultConversationFlowID
      defaultConversationFlow {
        id
        fundraisingCampaignID
        name
        description
        default
        active
        actionMessageDefinitions {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        restricted
        useDefaultCta
        customCta
        allowAmbassadorSpecificCrowbarVideos
        generalCrowbarVideoURI
        deleted
        createdAt
        updatedAt
      }
      useConversationFlows
      campaignPageID
      ambassadorPageID
      donationPageID
      discoveryPageID
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      subscriptionDonationTiers {
        items {
          id
          fundraisingCampaignID
          name
          description
          amount
          features
          buttonText
          buttonColor
          default
          highlighted
          highlightedColor
          promoText
          createdAt
          updatedAt
        }
        nextToken
      }
      useActionCardView
      createdAt
      updatedAt
      staffLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      recruitmentForCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      personalFundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      campaignPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      ambassadorPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      donationPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      discoveryPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      onDemandDiscoveryMeeting {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const listFundraisingCampaigns = /* GraphQL */ `
  query ListFundraisingCampaigns(
    $filter: ModelFundraisingCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaigns(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      nextToken
    }
  }
`;
export const listFundraisingCampaignsByOrganization = /* GraphQL */ `
  query ListFundraisingCampaignsByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      nextToken
    }
  }
`;
export const getCampaignPage = /* GraphQL */ `
  query GetCampaignPage($id: ID!) {
    getCampaignPage(id: $id) {
      id
      name
      description
      type
      fundraisingCampaignID
      campaignDisplayConfigurationID
      pageHtml
      pageJSON
      pageCssJSON
      pageAssetsJSON
      createdAt
      updatedAt
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
      campaignDisplayConfiguration {
        id
        campaignPageID
        primaryColor
        secondaryColor
        gradientLeftColor
        gradientRightColor
        buttonBackgroundColor
        buttonTextColor
        headerFont
        bodyFont
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const listCampaignPages = /* GraphQL */ `
  query ListCampaignPages(
    $filter: ModelCampaignPageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignPages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const listCampaignPagesByFundraisingCampaign = /* GraphQL */ `
  query ListCampaignPagesByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignPageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignPagesByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      nextToken
    }
  }
`;
export const getCampaignDisplayConfiguration = /* GraphQL */ `
  query GetCampaignDisplayConfiguration($id: ID!) {
    getCampaignDisplayConfiguration(id: $id) {
      id
      campaignPageID
      primaryColor
      secondaryColor
      gradientLeftColor
      gradientRightColor
      buttonBackgroundColor
      buttonTextColor
      headerFont
      bodyFont
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listCampaignDisplayConfigurations = /* GraphQL */ `
  query ListCampaignDisplayConfigurations(
    $filter: ModelCampaignDisplayConfigurationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignDisplayConfigurations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        campaignPageID
        primaryColor
        secondaryColor
        gradientLeftColor
        gradientRightColor
        buttonBackgroundColor
        buttonTextColor
        headerFont
        bodyFont
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getNylasEvent = /* GraphQL */ `
  query GetNylasEvent($id: ID!) {
    getNylasEvent(id: $id) {
      id
      calendarID
      owner
      fundraisingCampaignDiscoveryCallID
      status
      createdAt
      updatedAt
    }
  }
`;
export const listNylasEvents = /* GraphQL */ `
  query ListNylasEvents(
    $filter: ModelNylasEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNylasEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        calendarID
        owner
        fundraisingCampaignDiscoveryCallID
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFundraisingCampaignDiscoveryCall = /* GraphQL */ `
  query GetFundraisingCampaignDiscoveryCall($id: ID!) {
    getFundraisingCampaignDiscoveryCall(id: $id) {
      id
      title
      organizationID
      fundraisingCampaignID
      staffProfileID
      startTimestamp
      endTimestamp
      latentHosted
      invitationURL
      nylasEventID
      virtualMeetingURL
      createdAt
      updatedAt
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
export const listFundraisingCampaignDiscoveryCalls = /* GraphQL */ `
  query ListFundraisingCampaignDiscoveryCalls(
    $filter: ModelFundraisingCampaignDiscoveryCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignDiscoveryCalls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listFundraisingCampaignDiscoveryCallsByOrganization = /* GraphQL */ `
  query ListFundraisingCampaignDiscoveryCallsByOrganization(
    $organizationID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignDiscoveryCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignDiscoveryCallsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listFundraisingCampaignDiscoveryCallsByFundraisingCampaign = /* GraphQL */ `
  query ListFundraisingCampaignDiscoveryCallsByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignDiscoveryCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignDiscoveryCallsByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const getFundraisingCampaignDiscoveryCallByNylasEventID = /* GraphQL */ `
  query GetFundraisingCampaignDiscoveryCallByNylasEventID(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignDiscoveryCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getFundraisingCampaignDiscoveryCallByNylasEventID(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const getDiscoveryCallParticipant = /* GraphQL */ `
  query GetDiscoveryCallParticipant($id: ID!) {
    getDiscoveryCallParticipant(id: $id) {
      id
      email
      phoneNumber
      firstName
      lastName
      authAccountID
      fundraisingProfileID
      fundraisingCampaignDiscoveryCallID
      fundraisingCampaignID
      invitationSent
      icsString
      status
      recruitedByCampaignAmbassadorID
      confirmed
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      fundraisingCampaignDiscoveryCall {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const listDiscoveryCallParticipants = /* GraphQL */ `
  query ListDiscoveryCallParticipants(
    $filter: ModelDiscoveryCallParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscoveryCallParticipants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listDiscoveryCallParticipationByEmail = /* GraphQL */ `
  query ListDiscoveryCallParticipationByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelDiscoveryCallParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscoveryCallParticipationByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listDiscoveryCallParticipationByPhoneNumber = /* GraphQL */ `
  query ListDiscoveryCallParticipationByPhoneNumber(
    $phoneNumber: String
    $sortDirection: ModelSortDirection
    $filter: ModelDiscoveryCallParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscoveryCallParticipationByPhoneNumber(
      phoneNumber: $phoneNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listDiscoveryCallParticipationByAuthAccount = /* GraphQL */ `
  query ListDiscoveryCallParticipationByAuthAccount(
    $authAccountID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelDiscoveryCallParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscoveryCallParticipationByAuthAccount(
      authAccountID: $authAccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listDiscoveryCallParticipationByFundraisingProfile = /* GraphQL */ `
  query ListDiscoveryCallParticipationByFundraisingProfile(
    $fundraisingProfileID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelDiscoveryCallParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscoveryCallParticipationByFundraisingProfile(
      fundraisingProfileID: $fundraisingProfileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listDiscoveryCallParticipationByDiscoveryCall = /* GraphQL */ `
  query ListDiscoveryCallParticipationByDiscoveryCall(
    $fundraisingCampaignDiscoveryCallID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelDiscoveryCallParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscoveryCallParticipationByDiscoveryCall(
      fundraisingCampaignDiscoveryCallID: $fundraisingCampaignDiscoveryCallID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listDiscoveryCallParticipationByFundraisingCampaign = /* GraphQL */ `
  query ListDiscoveryCallParticipationByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelDiscoveryCallParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscoveryCallParticipationByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getFundraisingCampaignAmbassador = /* GraphQL */ `
  query GetFundraisingCampaignAmbassador($id: ID!) {
    getFundraisingCampaignAmbassador(id: $id) {
      id
      status
      commitment
      fundraisingProfileID
      fundraisingCampaignID
      discoveryCallParticipantID
      fundsRaised
      initialTransactionID
      initialTransactionAmount
      ambassadorSpecificCtaUrl
      ambassadorSpecificVideoUrl
      recruitedByCampaignAmbassadorID
      classyTeamID
      classySupporterID
      classyFundraiserPageID
      notificationsEnabled
      createdAt
      updatedAt
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaignAmbassadorContacts {
        items {
          id
          deviceContactID
          fundraisingProfileID
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          sentText
          sentTextTimestamp
          sentInitialTextReminder
          sentInitialTextReminderTimestamp
          sentPhoneCallScript
          sentPhoneCallScriptTimestamp
          called
          calledTimestamp
          sentFollowUp
          sentFollowUpTimestamp
          followUpResponse
          sentReminder
          sentReminderTimestamp
          isDonating
          donationAmount
          discoveryCallParticipantID
          transactionID
          isActive
          notes
          birthday
          hasTakenAction
          hasTakenActionTimestamp
          occupation
          selectedPhoneNumberArrayIndex
          actionMessages {
            nextToken
          }
          createdAt
          updatedAt
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const listFundraisingCampaignAmbassadors = /* GraphQL */ `
  query ListFundraisingCampaignAmbassadors(
    $filter: ModelFundraisingCampaignAmbassadorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignAmbassadors(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listFundraisingCampaignAmbassadorsByFundraisingProfile = /* GraphQL */ `
  query ListFundraisingCampaignAmbassadorsByFundraisingProfile(
    $fundraisingProfileID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignAmbassadorsByFundraisingProfile(
      fundraisingProfileID: $fundraisingProfileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listFundraisingCampaignAmbassadorsByCampaign = /* GraphQL */ `
  query ListFundraisingCampaignAmbassadorsByCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignAmbassadorsByCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getFundraisingCampaignAmbassadorByFundraisingProfileAndFundraisingCampaign = /* GraphQL */ `
  query GetFundraisingCampaignAmbassadorByFundraisingProfileAndFundraisingCampaign(
    $fundraisingProfileID: ID
    $fundraisingCampaignID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getFundraisingCampaignAmbassadorByFundraisingProfileAndFundraisingCampaign(
      fundraisingProfileID: $fundraisingProfileID
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getFundraisingCampaignAmbassadorContact = /* GraphQL */ `
  query GetFundraisingCampaignAmbassadorContact($id: ID!) {
    getFundraisingCampaignAmbassadorContact(id: $id) {
      id
      deviceContactID
      fundraisingProfileID
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      sentText
      sentTextTimestamp
      sentInitialTextReminder
      sentInitialTextReminderTimestamp
      sentPhoneCallScript
      sentPhoneCallScriptTimestamp
      called
      calledTimestamp
      sentFollowUp
      sentFollowUpTimestamp
      followUpResponse
      sentReminder
      sentReminderTimestamp
      isDonating
      donationAmount
      discoveryCallParticipantID
      transactionID
      isActive
      notes
      birthday
      hasTakenAction
      hasTakenActionTimestamp
      occupation
      selectedPhoneNumberArrayIndex
      actionMessages {
        items {
          id
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          fundraisingCampaignAmbassadorContactID
          actionMessageDefinitionID
          actionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          sent
          sentTimestamp
          response
          responseTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      fundraisingCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
export const listFundraisingCampaignAmbassadorContacts = /* GraphQL */ `
  query ListFundraisingCampaignAmbassadorContacts(
    $filter: ModelFundraisingCampaignAmbassadorContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignAmbassadorContacts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceContactID
        fundraisingProfileID
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        sentText
        sentTextTimestamp
        sentInitialTextReminder
        sentInitialTextReminderTimestamp
        sentPhoneCallScript
        sentPhoneCallScriptTimestamp
        called
        calledTimestamp
        sentFollowUp
        sentFollowUpTimestamp
        followUpResponse
        sentReminder
        sentReminderTimestamp
        isDonating
        donationAmount
        discoveryCallParticipantID
        transactionID
        isActive
        notes
        birthday
        hasTakenAction
        hasTakenActionTimestamp
        occupation
        selectedPhoneNumberArrayIndex
        actionMessages {
          items {
            id
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            fundraisingCampaignAmbassadorContactID
            actionMessageDefinitionID
            sent
            sentTimestamp
            response
            responseTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listContactsByFundraisingProfileCampaign = /* GraphQL */ `
  query ListContactsByFundraisingProfileCampaign(
    $fundraisingProfileID: ID
    $fundraisingCampaignID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactsByFundraisingProfileCampaign(
      fundraisingProfileID: $fundraisingProfileID
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceContactID
        fundraisingProfileID
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        sentText
        sentTextTimestamp
        sentInitialTextReminder
        sentInitialTextReminderTimestamp
        sentPhoneCallScript
        sentPhoneCallScriptTimestamp
        called
        calledTimestamp
        sentFollowUp
        sentFollowUpTimestamp
        followUpResponse
        sentReminder
        sentReminderTimestamp
        isDonating
        donationAmount
        discoveryCallParticipantID
        transactionID
        isActive
        notes
        birthday
        hasTakenAction
        hasTakenActionTimestamp
        occupation
        selectedPhoneNumberArrayIndex
        actionMessages {
          items {
            id
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            fundraisingCampaignAmbassadorContactID
            actionMessageDefinitionID
            sent
            sentTimestamp
            response
            responseTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listContactsByFundraisingCampaignAmbassador = /* GraphQL */ `
  query ListContactsByFundraisingCampaignAmbassador(
    $fundraisingCampaignAmbassadorID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactsByFundraisingCampaignAmbassador(
      fundraisingCampaignAmbassadorID: $fundraisingCampaignAmbassadorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceContactID
        fundraisingProfileID
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        sentText
        sentTextTimestamp
        sentInitialTextReminder
        sentInitialTextReminderTimestamp
        sentPhoneCallScript
        sentPhoneCallScriptTimestamp
        called
        calledTimestamp
        sentFollowUp
        sentFollowUpTimestamp
        followUpResponse
        sentReminder
        sentReminderTimestamp
        isDonating
        donationAmount
        discoveryCallParticipantID
        transactionID
        isActive
        notes
        birthday
        hasTakenAction
        hasTakenActionTimestamp
        occupation
        selectedPhoneNumberArrayIndex
        actionMessages {
          items {
            id
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            fundraisingCampaignAmbassadorContactID
            actionMessageDefinitionID
            sent
            sentTimestamp
            response
            responseTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listContactsByFundraisingCampaign = /* GraphQL */ `
  query ListContactsByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactsByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceContactID
        fundraisingProfileID
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        sentText
        sentTextTimestamp
        sentInitialTextReminder
        sentInitialTextReminderTimestamp
        sentPhoneCallScript
        sentPhoneCallScriptTimestamp
        called
        calledTimestamp
        sentFollowUp
        sentFollowUpTimestamp
        followUpResponse
        sentReminder
        sentReminderTimestamp
        isDonating
        donationAmount
        discoveryCallParticipantID
        transactionID
        isActive
        notes
        birthday
        hasTakenAction
        hasTakenActionTimestamp
        occupation
        selectedPhoneNumberArrayIndex
        actionMessages {
          items {
            id
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            fundraisingCampaignAmbassadorContactID
            actionMessageDefinitionID
            sent
            sentTimestamp
            response
            responseTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listContactsByDeviceContact = /* GraphQL */ `
  query ListContactsByDeviceContact(
    $deviceContactID: ID
    $fundraisingCampaignAmbassadorID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactsByDeviceContact(
      deviceContactID: $deviceContactID
      fundraisingCampaignAmbassadorID: $fundraisingCampaignAmbassadorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceContactID
        fundraisingProfileID
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        sentText
        sentTextTimestamp
        sentInitialTextReminder
        sentInitialTextReminderTimestamp
        sentPhoneCallScript
        sentPhoneCallScriptTimestamp
        called
        calledTimestamp
        sentFollowUp
        sentFollowUpTimestamp
        followUpResponse
        sentReminder
        sentReminderTimestamp
        isDonating
        donationAmount
        discoveryCallParticipantID
        transactionID
        isActive
        notes
        birthday
        hasTakenAction
        hasTakenActionTimestamp
        occupation
        selectedPhoneNumberArrayIndex
        actionMessages {
          items {
            id
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            fundraisingCampaignAmbassadorContactID
            actionMessageDefinitionID
            sent
            sentTimestamp
            response
            responseTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listContactsByInitialTextTimestamp = /* GraphQL */ `
  query ListContactsByInitialTextTimestamp(
    $sentTextTimestamp: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactsByInitialTextTimestamp(
      sentTextTimestamp: $sentTextTimestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceContactID
        fundraisingProfileID
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        sentText
        sentTextTimestamp
        sentInitialTextReminder
        sentInitialTextReminderTimestamp
        sentPhoneCallScript
        sentPhoneCallScriptTimestamp
        called
        calledTimestamp
        sentFollowUp
        sentFollowUpTimestamp
        followUpResponse
        sentReminder
        sentReminderTimestamp
        isDonating
        donationAmount
        discoveryCallParticipantID
        transactionID
        isActive
        notes
        birthday
        hasTakenAction
        hasTakenActionTimestamp
        occupation
        selectedPhoneNumberArrayIndex
        actionMessages {
          items {
            id
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            fundraisingCampaignAmbassadorContactID
            actionMessageDefinitionID
            sent
            sentTimestamp
            response
            responseTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listContactsByFollowUpMessageTimestamp = /* GraphQL */ `
  query ListContactsByFollowUpMessageTimestamp(
    $sentFollowUpTimestamp: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignAmbassadorContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactsByFollowUpMessageTimestamp(
      sentFollowUpTimestamp: $sentFollowUpTimestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceContactID
        fundraisingProfileID
        fundraisingCampaignID
        fundraisingCampaignAmbassadorID
        sentText
        sentTextTimestamp
        sentInitialTextReminder
        sentInitialTextReminderTimestamp
        sentPhoneCallScript
        sentPhoneCallScriptTimestamp
        called
        calledTimestamp
        sentFollowUp
        sentFollowUpTimestamp
        followUpResponse
        sentReminder
        sentReminderTimestamp
        isDonating
        donationAmount
        discoveryCallParticipantID
        transactionID
        isActive
        notes
        birthday
        hasTakenAction
        hasTakenActionTimestamp
        occupation
        selectedPhoneNumberArrayIndex
        actionMessages {
          items {
            id
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            fundraisingCampaignAmbassadorContactID
            actionMessageDefinitionID
            sent
            sentTimestamp
            response
            responseTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const getFundraisingCampaignUpdate = /* GraphQL */ `
  query GetFundraisingCampaignUpdate($id: ID!) {
    getFundraisingCampaignUpdate(id: $id) {
      id
      fundraisingCampaignID
      public
      message
      assetsUploaded
      updateURL
      createdByStaffProfileID
      live
      liveTimestamp
      createdAt
      updatedAt
      createdByStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
export const listFundraisingCampaignUpdates = /* GraphQL */ `
  query ListFundraisingCampaignUpdates(
    $filter: ModelFundraisingCampaignUpdateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignUpdates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        public
        message
        assetsUploaded
        updateURL
        createdByStaffProfileID
        live
        liveTimestamp
        createdAt
        updatedAt
        createdByStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listFundraisingCampaignUpdatesByFundraisingCampaign = /* GraphQL */ `
  query ListFundraisingCampaignUpdatesByFundraisingCampaign(
    $fundraisingCampaignID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelFundraisingCampaignUpdateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundraisingCampaignUpdatesByFundraisingCampaign(
      fundraisingCampaignID: $fundraisingCampaignID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundraisingCampaignID
        public
        message
        assetsUploaded
        updateURL
        createdByStaffProfileID
        live
        liveTimestamp
        createdAt
        updatedAt
        createdByStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      nextToken
    }
  }
`;
